export default __webpack_public_path__ + "static/media/service.4922df21.png";